<template>
  <div class="forget-page">
    <div class="content-scroll">
      <div class="content-card">
        <p class="form-desc">请输入您的ID或注册邮箱，系统将向您的邮箱发送重置密码链接：</p>

        <el-form :model="form" ref="form" label-position="top" class="forget-form">
          <el-form-item prop="nameOrEmail">
            <el-input
              type="text"
              v-model="nameOrEmail"
              placeholder="请输入ID或者注册邮箱"
              prefix-icon="el-icon-message"
            ></el-input>
          </el-form-item>

          <el-form-item prop="captcha" class="captcha-form-item">
            <div class="captcha-row">
              <el-input
                type="text"
                class="captcha-input"
                maxlength="4"
                v-model="captcha"
                @keyup.enter.native="sendForgetPasswordEmail"
                placeholder="请输入验证码"
              ></el-input>
              <img
                class="captcha-img"
                alt="点击更换"
                title="点击更换"
                @click="changeCode"
                :src="codeImgSrc"
              />
            </div>
          </el-form-item>

          <el-form-item class="submit-form-item">
            <el-button
              type="primary"
              class="submit-btn"
              :loading="loading"
              @click.native.prevent="sendForgetPasswordEmail"
            >提 交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="bottom-fixed">
      <div class="back-link">
        <router-link :to="{name:'login'}">← 返回登录</router-link>
      </div>
      <div class="page-footer">
        <div class="copyright">
          ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
        </div>
        <div class="advice">
          抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {postJson, postRequest, getRequest} from '../../utils/api'
  import Message from 'element-ui/lib/message'
  export default{
    methods: {
        checkInput: function(_this) {
            if (_this.nameOrEmail=="") {
                Message.error('ID或者注册邮箱不能为空！');
                return false;
            }
            if (_this.captcha=="") {
                Message.error('验证码不能为空！');
                return false;
            }
            return true;
        },
        changeCode: function() {
            var _this = this;
            postRequest('/auth/login/getCaptcha', {
            }).then(resp=> {
                if (resp.status == 200) {
                //成功
                var respData = resp.data;
                if (200 == respData.status) {
                    _this.codeImgSrc = "data:image/jpg;base64," + respData.data
                } else {
                    // 不递归重试，避免接口异常时无限刷
                    Message.error(respData.message);
                }

                } else {
                //失败
                Message.error('验证码加载失败!');
                }
            }, resp=> {
                Message.error('找不到服务器⊙﹏⊙∥!');
            });
        },
        sendForgetPasswordEmail: function() {
            var _this = this;
            if (!_this.checkInput(_this)) {
                return;
            }
            this.loading = true;
postJson('/auth/mail/sendForgetPasswordEmail', {
    nameOrEmail: this.nameOrEmail,
    captcha: this.captcha
}).then(resp=> {
                _this.loading = false;
                if (resp.status == 200) {
                //成功
                var respData = resp.data;
                if (200 == respData.status) {
                  Message.success('忘记密码提交成功，请登录邮箱' + respData.message + '获取重置密码链接。');
                  this.$router.back(-1);
                } else {
                    Message.error(respData.message);
                    _this.captcha = "";
                    _this.changeCode();
                }

                } else {
                //失败
                _this.loading = false;
                Message.error('忘记密码提交失败!');
                }
            }, resp=> {
                _this.loading = false;
                Message.error('找不到服务器⊙﹏⊙∥!');
            });
        }
    },
    mounted: function () {
      var _this = this;
      this.changeCode();
    },
    data(){
        return {
            loading: false,
            nameOrEmail: "",
            codeImgSrc: '',
            captcha: ''
        }
    }
  }
  
</script>
<style scoped>
.forget-page {
  flex: 1;
  min-height: 0;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0;
}

/* ========== 正文滚动区 ========== */
.content-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px 12px 0;
}

.content-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 32px 30px;
  box-sizing: border-box;
}

.form-desc {
  margin: 0 0 24px;
  font-size: 14px;
  line-height: 1.8;
  color: #606266;
  text-align: center;
}

/* ========== 表单 ========== */
.forget-form .el-form-item {
  margin-bottom: 16px;
}

.forget-form .el-input__inner {
  border-radius: 8px;
  height: 44px;
  line-height: 44px;
  font-size: 15px;
}

.captcha-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.captcha-input {
  flex: 1;
}

.captcha-img {
  width: 110px;
  height: 44px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  flex-shrink: 0;
  object-fit: contain;
  background: #fafafa;
  transition: border-color 0.2s;
}

.captcha-img:hover {
  border-color: #409eff;
}

.submit-form-item {
  margin-bottom: 0;
}

.submit-btn {
  width: 100%;
  height: 46px;
  border-radius: 8px;
  font-size: 16px;
  letter-spacing: 6px;
}

/* ========== 底部固定区 ========== */
.bottom-fixed {
  flex-shrink: 0;
  padding: 0 16px;
}

.back-link {
  text-align: center;
  padding: 10px 0;
}

.back-link a {
  font-size: 14px;
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}

.back-link a:hover {
  color: #409eff;
}

.page-footer {
  text-align: center;
  padding-bottom: 16px;
}

.page-footer .copyright {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.page-footer .copyright a {
  color: #909399;
  text-decoration: none;
}

.page-footer .copyright a:hover {
  color: #409eff;
}

.page-footer .advice {
  font-size: 11px;
  color: #aaa;
  line-height: 1.7;
  margin-top: 4px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .content-scroll {
    padding: 8px 8px 0;
  }

  .content-card {
    padding: 24px 16px;
    border-radius: 10px;
  }

  .form-desc {
    font-size: 13px;
    margin-bottom: 18px;
  }

  .forget-form .el-input__inner {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }

  .captcha-img {
    width: 100px;
    height: 40px;
  }

  .submit-btn {
    height: 42px;
    font-size: 15px;
  }

  .back-link a {
    font-size: 13px;
  }

  .bottom-fixed {
    padding: 0 10px;
  }

  .page-footer .copyright {
    font-size: 10px;
  }

  .page-footer .advice {
    font-size: 10px;
  }
}
</style>
